// Call account data
import { apiAuth, apiPublic } from '../../utils/hooks';

const getAccount = (token, idAccount, mode) => {
    return apiAuth(mode, token)
        .get(`/account/${idAccount}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const newLogin = (client_id, username, password) =>
    apiPublic().post(`/user-login`, {
        client_id,
        grant_type: 'password',
        password,
        username,
    });

export { getAccount, newLogin };
